export default __webpack_public_path__ + "static/SSSpyView_screenshot-1-77d99ec4e492ba7f7a9e5b929020723e.jpg";